import {cloneVDom, CreateWidgetFromFirebaseNode} from "../components/v3/lib/vue-dom-obj";
import {ConvrrtFirebase} from "../convrrt-firebase";
import {PageEngineCommands} from "./AddSectionCommand";
import _ from "lodash";


export class PopupInsertBlockCommand extends PageEngineCommands {
    constructor(pageEngineComponent, blockData, rootPathKey) {
        super();
        this._pageEngineComponent = pageEngineComponent

        this._newNodeBlocks = [blockData]
        this._newVDom = cloneVDom([_.clone(blockData)], rootPathKey)

        this._oldNodeBlocks = this.clonedVDom.map(x => CreateWidgetFromFirebaseNode(x.node))
        this._oldVDom = [...this.clonedVDom]
        this._firebaseRef = new ConvrrtFirebase(rootPathKey)
    }

    get firebaseRef () {
        return this._firebaseRef
    }

    get hasChanges () {
        return true
    }

    async execute() {
        this.firebaseRef.set(this._newNodeBlocks).then(() => {
            this.clonedVDom = [...this._newVDom]
        })
    }

    async unExecute() {
        this.firebaseRef.set(this._oldNodeBlocks).then(() => {
            this.clonedVDom = [...this._oldVDom]
        })
    }
}
